/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svc_Automation_Custom_Title6Inputs */

const en_svc_automation_custom_title6 = /** @type {(inputs: Svc_Automation_Custom_Title6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Beyond the off-the-shelf`)
};

const ar_svc_automation_custom_title6 = /** @type {(inputs: Svc_Automation_Custom_Title6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ما وراء الجاهز`)
};

const bn_svc_automation_custom_title6 = /** @type {(inputs: Svc_Automation_Custom_Title6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`রেডি-মেডের বাইরে`)
};

const de_svc_automation_custom_title6 = /** @type {(inputs: Svc_Automation_Custom_Title6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mehr als die Standardlösung`)
};

const es_svc_automation_custom_title6 = /** @type {(inputs: Svc_Automation_Custom_Title6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Más allá del estándar`)
};

const fr_svc_automation_custom_title6 = /** @type {(inputs: Svc_Automation_Custom_Title6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Au-delà du standard`)
};

const pt_svc_automation_custom_title6 = /** @type {(inputs: Svc_Automation_Custom_Title6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Além do pronto para uso`)
};

const zh_svc_automation_custom_title6 = /** @type {(inputs: Svc_Automation_Custom_Title6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`超越现成的`)
};

const tr_svc_automation_custom_title6 = /** @type {(inputs: Svc_Automation_Custom_Title6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kullanıma hazırın ötesinde`)
};

const ru_svc_automation_custom_title6 = /** @type {(inputs: Svc_Automation_Custom_Title6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`За пределами стандартного`)
};

const pl_svc_automation_custom_title6 = /** @type {(inputs: Svc_Automation_Custom_Title6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Poza standardem`)
};

/**
* | output |
* | --- |
* | "Beyond the off-the-shelf" |
*
* @param {Svc_Automation_Custom_Title6Inputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
const svc_automation_custom_title6 = /** @type {((inputs?: Svc_Automation_Custom_Title6Inputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svc_Automation_Custom_Title6Inputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_svc_automation_custom_title6(inputs)
	if (locale === "bn") return bn_svc_automation_custom_title6(inputs)
	if (locale === "de") return de_svc_automation_custom_title6(inputs)
	if (locale === "es") return es_svc_automation_custom_title6(inputs)
	if (locale === "fr") return fr_svc_automation_custom_title6(inputs)
	if (locale === "pt") return pt_svc_automation_custom_title6(inputs)
	if (locale === "zh") return zh_svc_automation_custom_title6(inputs)
	if (locale === "tr") return tr_svc_automation_custom_title6(inputs)
	if (locale === "ru") return ru_svc_automation_custom_title6(inputs)
	if (locale === "pl") return pl_svc_automation_custom_title6(inputs)
	return en_svc_automation_custom_title6(inputs)
});
export { svc_automation_custom_title6 as "svc_automation_CUSTOM_title" }